import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function CSR() {
  const { t } = useTranslation();
  return (
    <section id="csr" className="bg-[#255485]/8 py-16 sm:py-24">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <p className="text-[#255485] text-sm font-medium tracking-wider mb-2">{t('csr.eyebrow')}</p>
          <h2 className="text-2xl sm:text-3xl font-serif text-gray-900">{t('csr.title')}</h2>
        </div>
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-3xl overflow-hidden h-64 sm:h-80 lg:h-96">
              <img
                src="https://public.readdy.ai/ai/img_res/a177bca7910418f1c756f0ca2f68791e.jpg"
                alt="Youth Sports Coaching"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <div className="inline-block bg-[#255485] text-white text-xs font-semibold px-4 py-2 rounded-full mb-4 sm:mb-6">
              {t('csr.badge')}
            </div>
            <h3 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">{t('csr.heading')}</h3>
            <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-6 sm:mb-8 whitespace-pre-line">
              {t('csr.body')}
              <br /><br />
              {t('csr.body2')}<strong className="text-[#255485]">{t('csr.body.highlight')}</strong>{t('csr.body3')}
            </p>
            <div className="flex items-start gap-3 sm:gap-4 bg-white p-4 sm:p-6 rounded-xl shadow-sm mb-6 sm:mb-8">
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center flex-shrink-0">
                <i className="ri-trophy-line text-2xl sm:text-3xl text-[#255485]"></i>
              </div>
              <div>
                <p className="text-sm sm:text-base text-gray-800 font-medium mb-2">{t('csr.card.title')}</p>
                <p className="text-xs sm:text-sm text-gray-600 leading-relaxed">{t('csr.card.desc')}</p>
              </div>
            </div>
            <Link
              to="/csr"
              className="inline-flex items-center gap-2 bg-[#255485] text-white px-6 sm:px-8 py-3 sm:py-3.5 rounded-lg hover:bg-[#1d4166] transition-colors duration-200 font-medium cursor-pointer whitespace-nowrap text-sm sm:text-base"
            >
              {t('csr.link')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
